
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exchange/[[...slug]]",
      function () {
        return require("private-next-pages/exchange/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exchange/[[...slug]]"])
      });
    }
  